module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "xs6 mt-1",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.props.companylogo,
      "height": "120px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "white--text pl-2 mt-2",
    attrs: {
      "src": _vm.props.companylogo,
      "contain": true
    }
  }, [_c('v-layout', {
    staticClass: "media",
    attrs: {
      "column": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-card-title', {
    staticClass: "white--text pl-2"
  }, [_c('div', {
    staticClass: "display-1 pl-2",
    staticStyle: {
      "color": "#000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.props.companylegalname) + "\n          "), (_vm.props.verified) ? _c('v-icon', {
    attrs: {
      "small": "",
      "right": true,
      "primary": ""
    }
  }, [_vm._v("verified_user")]) : _vm._e(), _vm._v(" "), (!_vm.props.verified) ? _c('v-icon', {
    attrs: {
      "color": "red",
      "small": "",
      "right": true
    }
  }, [_vm._v("error")]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "ma-1 mt-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": "",
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Full Name")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.firstname) + " " + _vm._s(_vm.props.lastname))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Street Address")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.streetaddress))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Phone Number")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.phonenumber))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Email Address")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.email))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("settings_overscan")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Federal Contractor")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.fedcontractor ? 'Yes' : 'No'))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("toc")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Federal Contractor Type")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.fedcontractortype))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Security Clearance")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.securityclearance))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ma-1 mt-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": "",
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-tile')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("explore")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Duns Number")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.dunsnumber))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("extension")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Cage ID")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.cagecode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary NAICS Code")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.primarynaicscode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("dialpad")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional NAICS Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.additionalnaicscodes))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("dialpad")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Primary PSC Code")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.primarypsccode))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("dialpad")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Additional PSC Codes")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.additionalpsccodes))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "ma-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": "",
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Specialties")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.specialties))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("pan_tool")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Capabilities")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(_vm.props.capabilities))])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("chrome_reader_mode")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Capabilities Statements")]), _vm._v(" "), _c('v-list-tile-title', [(_vm.props.capabilitiesstatement) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.props.capabilitiesstatement,
      "round": "",
      "color": "red lighten-1",
      "dark": ""
    }
  }, [_vm._v("View PDF")]) : _vm._e(), _vm._v(" "), (!_vm.props.capabilitiesstatement) ? _c('span', [_vm._v("Not Available")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("description")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_vm._v("Description")]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(_vm.props.companydescription) + "\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5a8149","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Request/company/company_info.vue
// module id = 1229
// module chunks = 3 4